<template>
    <v-card v-observe-visibility="visibilityChanged">
        <v-toolbar light color="white">
            <v-btn icon @click.native="closeNewDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add New Terms Of Payments</v-toolbar-title>
            <v-toolbar-title v-else>Edit Terms Of Payments - {{selectedItem.name}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs
                color="secondary"
                dark
                slider-color="primary"
        >
            <v-tab>Terms Of Payments</v-tab>
            <v-tab-item>
                <v-progress-linear class="top-loading" :active="loading"
                                   :indeterminate="true"></v-progress-linear>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 md8 offset-md2 xl4 offset-xl4>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-card dark color="secondary">
                                            <v-card-title>General</v-card-title>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="selectedItem.name"
                                                label="Name">
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="selectedItem.days"
                                                label="Days">
                                        </v-text-field>
                                    </v-flex>

                                </v-layout>

                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-card dark color="secondary">
                                            <v-card-title>Optional Info</v-card-title>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-textarea
                                                lenght
                                                v-model="selectedItem.description"
                                                label="Description"
                                                counter
                                                maxlength="255"
                                        >
                                        </v-textarea>
                                    </v-flex>

                                </v-layout>

                                <v-layout mt-5 row justify-end>
                                    <v-btn :disabled="formEdited" mt-5 color="secondary" @click.native="saveItem(0)">
                                        Save
                                        <v-icon class="white--text" right>save</v-icon>
                                    </v-btn>
                                </v-layout>

                            </v-flex>

                        </v-layout>


                    </v-container>
                </v-card-text>
            </v-tab-item>

        </v-tabs>

    </v-card>
</template>


<script>
    import {
        Settings,
        TermsOfPaymentSettings
    } from '../../store/namespace-helper'

    export default {
      name: 'add-new-terms-of-payment',
      data () {
        return {
          isVisible: false,
          onDismissed: false,
          formUpdated: 0
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.formUpdated = 0
            } else {
              this.formUpdated = 0
            }
          }
        },
        closeNewDialog () {
          this.$store.dispatch(TermsOfPaymentSettings.actions.setSelectedTermOfPayment, null)
          this.$store.dispatch(TermsOfPaymentSettings.actions.openCloseNewDialog)
        },
        saveItem (index) {
          this.$store.dispatch(TermsOfPaymentSettings.actions.saveTermOfPayment, this.selectedItem)
          this.formUpdated = 0
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        }

      },
      computed: {
        dialog () {
          return this.$store.getters[TermsOfPaymentSettings.getters.getOpenNewDialogState]
        },
        selectedItem () {
          console.log('selected terms of payment: ' + JSON.stringify(this.$store.getters[TermsOfPaymentSettings.getters.getSelectedTermOfPayment]))
          return this.$store.getters[TermsOfPaymentSettings.getters.getSelectedTermOfPayment]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        formEdited () {
          return this.formUpdated < 1
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        }

      },
      watch: {
        selectedItem: {
          handler (val) {
            console.log('formUpdated data changed: ' + JSON.stringify(val))
            this.formUpdated++
            console.log('formUpdated:' + this.formUpdated)
          },
          deep: true
        }
      }
    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .top-loading {
        margin-top: 0px;
    }


</style>


// WEBPACK FOOTER //
// src/components/Shared/AddTermsOfPayment.vue